/* Next10 — carrinho lateral.
   Substitui o cart-drawer do Dawn, mantendo a API que o product-form.js espera
   (getSectionsToRender, setActiveElement, renderContents, open, close). */

if (!customElements.get('cart-drawer')) {
  class N10CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.aberto = false;
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    connectedCallback() {
      this.ligarGatilhos();
      this.restaurarCupom();
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.aberto) this.close();
      });
    }

    /* ---------- gatilhos de abertura ---------- */
    ligarGatilhos() {
      if (this.gatilhosLigados) return;
      this.gatilhosLigados = true;

      document.addEventListener('click', (e) => {
        if (!e.target.closest) return;
        const alvo = e.target.closest('#cart-icon-bubble, [data-n10-cart-open], a[href$="/cart"]');
        if (!alvo) return;
        if (alvo.matches('a') && (e.metaKey || e.ctrlKey || e.shiftKey || alvo.target === '_blank')) return;
        e.preventDefault();
        this.open(alvo);
      });
    }

    /* ---------- abrir / fechar ---------- */
    open(gatilho) {
      if (gatilho) this.activeElement = gatilho;
      /* O menu do celular nao se fecha sozinho quando o carrinho abre por cima
         dele (o link do carrinho fica dentro do proprio menu). O <details>
         continuava aberto e o overlay do tema -- summary::before, branco 50%
         porque o cabecalho e preto -- ficava pintado sobre o site inteiro
         depois que o carrinho fechava: a "pelicula" na frente da pagina. */
      const menu = document.querySelector('header-drawer, menu-drawer');
      const summary = menu && menu.querySelector('summary');
      /* o closeMenuDrawer do header-drawer so age quando recebe o elemento a
         focar: `elementToFocus && (super.closeMenuDrawer(...))`. */
      if (summary && menu.querySelector('details[open]') && typeof menu.closeMenuDrawer === 'function') {
        menu.closeMenuDrawer(new Event('n10-cart-open'), summary);
        /* o tema so tira o atributo `open` no transitionend do painel dele; o
           painel daqui e outro (n10-drawer.css) e nao dispara esse evento, e
           enquanto o <details> fica aberto o overlay continua pintado. */
        menu.querySelectorAll('details[open]').forEach((d) => d.removeAttribute('open'));
      }
      this.classList.add('active');
      this.aberto = true;
      document.documentElement.classList.add('n10-cart-aberto');
      const painel = this.querySelector('#CartDrawer');
      if (painel) setTimeout(() => painel.focus(), 320);
    }

    close() {
      this.classList.remove('active');
      this.aberto = false;
      document.documentElement.classList.remove('n10-cart-aberto');
      if (this.activeElement && this.activeElement.focus) this.activeElement.focus();
    }

    onKeydown(e) {
      if (e.key === 'Escape') this.close();
    }

    /* ---------- API usada pelo product-form.js do tema ---------- */
    getSectionsToRender() {
      return [
        { id: 'cart-drawer', selector: '#CartDrawer' },
        { id: 'cart-icon-bubble' },
      ];
    }

    setActiveElement(el) {
      this.activeElement = el;
    }

    renderContents(estado) {
      if (estado && estado.sections) this.renderSections(estado.sections);
      this.classList.remove('is-empty');
      this.open();
    }

    renderSections(sections) {
      this.getSectionsToRender().forEach((secao) => {
        const html = sections[secao.id];
        if (!html) return;
        const destino = secao.selector
          ? document.querySelector(secao.selector)
          : document.getElementById(secao.id);
        if (!destino) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const origem = doc.querySelector(secao.selector || '.shopify-section');
        if (origem) destino.innerHTML = origem.innerHTML;
      });
      this.classList.toggle('is-empty', !!this.querySelector('.n10-cart__empty'));
      this.restaurarCupom();
    }

    /* ---------- chamadas ao carrinho ---------- */
    pedir(url, corpo, item) {
      if (item) item.classList.add('is-loading');
      corpo.sections = this.getSectionsToRender().map((s) => s.id);
      corpo.sections_url = window.location.pathname;

      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corpo),
      })
        .then((r) => r.json())
        .then((dados) => {
          if (dados.sections) this.renderSections(dados.sections);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'n10-cart-drawer', cartData: dados });
          }
          return dados;
        })
        .catch(() => {
          if (item) item.classList.remove('is-loading');
        });
    }

    mudarQuantidade(key, quantidade, item) {
      return this.pedir(window.routes.cart_change_url, { id: key, quantity: quantidade }, item);
    }

    adicionar(variantId) {
      return this.pedir(window.routes.cart_add_url, { items: [{ id: variantId, quantity: 1 }] }).then((d) => {
        this.open();
        return d;
      });
    }

    /* ---------- cupom ---------- */
    aplicarCupom(codigo, msg) {
      const limpo = (codigo || '').trim();
      if (!limpo) return;
      msg.className = 'n10-cart__cupom-msg';
      msg.textContent = 'Aplicando…';

      fetch('/discount/' + encodeURIComponent(limpo), { method: 'GET' })
        .then((r) => {
          if (!r.ok) throw new Error();
          try { sessionStorage.setItem('n10-cupom', limpo); } catch (e) {}
          msg.className = 'n10-cart__cupom-msg is-ok';
          msg.textContent = 'Cupom ' + limpo.toUpperCase() + ' guardado. O desconto aparece no checkout.';
        })
        .catch(() => {
          msg.className = 'n10-cart__cupom-msg is-erro';
          msg.textContent = 'Não consegui aplicar esse cupom. Confira o código.';
        });
    }

    restaurarCupom() {
      let salvo = null;
      try { salvo = sessionStorage.getItem('n10-cupom'); } catch (e) {}
      if (!salvo) return;
      const input = this.querySelector('[data-n10-cupom-input]');
      const msg = this.querySelector('[data-n10-cupom-msg]');
      if (!input || !msg) return;
      input.value = salvo;
      msg.className = 'n10-cart__cupom-msg is-ok';
      msg.textContent = 'Cupom ' + salvo.toUpperCase() + ' guardado. O desconto aparece no checkout.';
    }

    /* ---------- interações dentro da gaveta ---------- */
    onClick(e) {
      const alvo = e.target;
      if (!alvo.closest) return;

      if (alvo.closest('[data-n10-cart-close]')) {
        e.preventDefault();
        this.close();
        return;
      }

      const botaoQtd = alvo.closest('[data-n10-qty]');
      if (botaoQtd) {
        e.preventDefault();
        const item = botaoQtd.closest('.n10-cart__item');
        const input = item.querySelector('[data-n10-qty-input]');
        const atual = parseInt(input.value, 10) || 0;
        const nova = botaoQtd.dataset.n10Qty === 'mais' ? atual + 1 : Math.max(0, atual - 1);
        this.mudarQuantidade(item.dataset.key, nova, item);
        return;
      }

      const remover = alvo.closest('[data-n10-remove]');
      if (remover) {
        e.preventDefault();
        const item = remover.closest('.n10-cart__item');
        this.mudarQuantidade(item.dataset.key, 0, item);
        return;
      }

      const add = alvo.closest('[data-n10-add]');
      if (add) {
        e.preventDefault();

        // Produto de variante unica traz o id no proprio botao; com mais de uma
        // variante o id vem do select ao lado ("Complete seu pedido").
        const linha = add.closest('.n10-up');
        const select = linha ? linha.querySelector('[data-n10-up-select]') : null;
        const variantId = add.dataset.n10Add || (select ? select.value : '');
        if (!variantId) return;

        const rotulo = add.textContent.trim() || 'Adicionar';
        add.disabled = true;
        add.textContent = 'Adicionando…';

        this.adicionar(variantId).then((dados) => {
          // Em caso de sucesso a gaveta e redesenhada e este botao deixa de existir.
          if (!dados || dados.status) {
            add.disabled = false;
            add.textContent = rotulo;
          }
        });
        return;
      }

      const cupomOk = alvo.closest('[data-n10-cupom-ok]');
      if (cupomOk) {
        e.preventDefault();
        const campo = this.querySelector('[data-n10-cupom-input]');
        const msg = this.querySelector('[data-n10-cupom-msg]');
        this.aplicarCupom(campo.value, msg);
      }
    }

    onChange(e) {
      const input = e.target.closest && e.target.closest('[data-n10-qty-input]');
      if (!input) return;
      const item = input.closest('.n10-cart__item');
      const nova = Math.max(0, parseInt(input.value, 10) || 0);
      this.mudarQuantidade(item.dataset.key, nova, item);
    }
  }

  customElements.define('cart-drawer', N10CartDrawer);
}

/* Enter no campo de cupom não deve enviar o formulário de checkout */
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter') return;
  const campo = e.target.closest && e.target.closest('[data-n10-cupom-input]');
  if (!campo) return;
  e.preventDefault();
  const gaveta = document.querySelector('cart-drawer');
  if (gaveta) gaveta.aplicarCupom(campo.value, gaveta.querySelector('[data-n10-cupom-msg]'));
});
